<template>
  <div class="app-wrapper">
    <div class="fixed-header">
      <app-header v-show="showHeader"></app-header>
    </div>

    <app-main />
  </div>
</template>

<script>
import AppHeader from './AppHeader';
import AppMain from './AppMain';
export default {
  name: 'Layout',
  components: {
    AppMain,
    AppHeader
  },
  data() {
    return {};
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
    showHeader() {
      return this.meta.showHeader !== false;
    }

  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  // overflow: auto;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  transition: width 0.28s;
}
</style>
